import React from 'react';
import styles from './PerformanceLegend.module.css';

/**
 * The colour key under a returns table — it names the three states
 * `PerformanceCell` paints, so the swatches read from the same tokens the cells
 * do and cannot drift apart.
 */
const PerformanceLegend: React.FC = () => (
  <div className={styles.legend}>
    <span className={styles.item}>
      <span className={`${styles.swatch} ${styles.positive}`} />
      Positive returns
    </span>
    <span className={styles.item}>
      <span className={`${styles.swatch} ${styles.negative}`} />
      Negative returns
    </span>
    <span className={styles.item}>
      <span className={`${styles.swatch} ${styles.failure}`} />
      No data available
    </span>
  </div>
);

export default PerformanceLegend;
